import { css } from "@emotion/react";
import styled, { ThemedCssCreator } from "../../../config/emotion";

type OuterContainerProps = {
  inline?: boolean;
  withYMargin?: boolean;
  noStretch?: boolean;
};

export const OuterContainer = styled.div<OuterContainerProps>`
  color: ${({ theme }) => theme.colors.primaryColor};
  border: 1px solid ${({ theme }) => theme.colors.primaryColor};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 25px;

  padding: 8px;
  ${(p) => !p.noStretch && "height: 100%; width: 100%;"}

  ${(p) => p.withYMargin && "margin: 10px 0;"};

  ${(p) => {
    const inlineVariantCss = `
      width: fit-content;
      height: fit-content;
      flex-direction: row;
      width: fit-content;
      font-size: 22px;
      padding-left: 15px;
      margin: 0;
    `;
    return p.inline && inlineVariantCss;
  }}
`;

export const actionCss: ThemedCssCreator = (theme) => css`
  color: ${theme.colors.secondaryColor};
  cursor: pointer;

  &:hover {
    transform: scale(1.2);
  }

  transition: all 0.25s;
  margin: 10px;
  font-size: 30px;
`;

export const actionContainerCss = css`
  display: flex;
`;
